"use client";

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from "next-intl";
import { Card, CardContent } from "@/components/ui/card";
import { RoomBillsSummary } from "@/components/modules/portfolio/room-bills/RoomBillsSummary";
import { withDefaultBills, type RoomBill } from "@/components/modules/portfolio/room-bills/roomBills";
type Props = {
  bills?: RoomBill[] | null;
};
export function RealEstateDetailBills(t0) {
  const $ = _c(11);
  const {
    bills
  } = t0;
  const t = useTranslations("modules.properties.roomBills");
  if (!bills) {
    return null;
  }
  let t1;
  if ($[0] !== t) {
    t1 = t("title");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <h2 className="text-xl font-bold mb-4 text-foreground-heading">{t1}</h2>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== bills) {
    t3 = withDefaultBills(bills);
    $[4] = bills;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <RoomBillsSummary bills={t3} data-sentry-element="RoomBillsSummary" data-sentry-source-file="RealEstateDetailBills.tsx" />;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = <Card className="bg-card border-none shadow-sm" data-sentry-element="Card" data-sentry-component="RealEstateDetailBills" data-sentry-source-file="RealEstateDetailBills.tsx"><CardContent data-sentry-element="CardContent" data-sentry-source-file="RealEstateDetailBills.tsx">{t2}{t4}</CardContent></Card>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}